var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlayerPlay = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "currentcolor",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m23.072 13.656-17.06 9.992C4.617 24.473 3 23.775 3 22.316V1.665C3 .237 4.68-.461 6.012.332l17.06 10.025c1.237.73 1.237 2.537 0 3.299"
})));
export default SvgPlayerPlay;